<template>
  <div>
    <date-range
      v-if="formateRangeDatasStatus"
      :title="rangeTitTxt"
      range
      type="dev"
      @memberChange="handleCascaderSubmit"
    />
    <date-range
      :title="overviewTitTxt"
      :date-data="dateData"
      @dateCallback="handleDateChange($event,0)"
    />
    <div class="dev-overview-div">
      <div
        v-for="(item,index) in devRecOverViewDatas"
        :key="index"
        class="dev-normal-content"
      >
        <span class="text">{{ item.name }}</span><span class="number">{{ item.num }}</span>
      </div>
    </div>
    <date-range
      :title="overviewTxt"
      :date-data="dateData"
      from-origin
      @messageChange="handleMessageChange"
      @dateCallback="handleDateChange($event,1)"
    />
    <div class="dev-distribute-div word_main">
      <HChart
        v-if="!isWordCloud"
        :id="distributeId"
        ref="distributeRef"
        style="height:100%;"
        :option="distributeOption"
      />
      <div
        v-else
        class="wordcloud"
      >
        <h-chart
          id="word"
          ref="wordRef"
          :option="wordcloudOption"
        />
        <div class="wordcloud_operate">
          <div class="pagin">
            <span @click="toPrev"><i :class="['iconfont', 'iconicon-test40', wordLegendPage === 1 && 'pagin_null']" /></span>
            <div
              class="page_select"
              @click="toSelectPage"
            >
              {{ wordLegendPage }}/{{ devDistributelist.maxPage }}<i class="iconfont iconicon-test17" />
            </div>
            <span @click="toNext"><i :class="['iconfont', 'iconicon-test18', wordLegendPage === devDistributelist.maxPage && 'pagin_null']" /></span>
          </div>
        </div>
      </div>
    </div>
    <date-range
      :title="dataTitTxt"
      group
      :groupname="defaultTeamName"
      :team-lists="teamLists"
      :date-data="dateData"
      :show-type-select="true"
      @teamSelectFollow="handleTeamSelectFollow"
      @dateCallback="handleDateChange($event,2)"
      @typeCallback="handleTypeChange"
    />
    <div class="dev-data-statistic">
      <div
        class="level-select-div"
        @click="handleLevelSelect"
      >
        <span class="level-select-text">{{ levelText }}</span><i class="iconfont iconicon-test18 level-icon" />
      </div>
      <div
        v-for="(items,indexs) in listDatas"
        :key="indexs"
        class="detail-content"
      >
        <div v-if="dataType===1">
          <div
            v-if="items[0]<=2"
            class="circle"
          >
            {{ items[0] }}
          </div>
          <div
            v-else
            class="circle-gray"
          >
            {{ items[0] }}
          </div>
          <span class="text-content-ellipsis">{{ items[1] }}</span>
          <span class="number">{{ items[2] }}</span>
        </div>
        <div v-else>
          <span class="date-second-data">{{ items[0] }}</span>
          <!-- <span class="date-second-num">{{ items[1] }}</span> -->
          <span class="date-second-number">{{ items[checkIndexs] }}</span>
        </div>
      </div>
    </div>
    <LevelSelect
      :visible.sync="visible"
      type="dev"
      @levelSelect="handleLevelSelectChange"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import HChart from '@/components/pc/HighChart.vue'
import { mobileDistributePieOptions, highChartWordCloudOption } from '@/lib/chart-option'
import { overviewData, formatePickerData } from '@/lib/statistic-utils'
import DateRange from './components/DateSelectComponents'
import LevelSelect from './components/LevelSelectComponents'
export default {
  components: {
    DateRange,
    HChart,
    LevelSelect
  },
  data () {
    return {
      visible: false,
      dateData: formatePickerData(overviewData),
      distributeId: 'distributeId',
      distributeOption: mobileDistributePieOptions(),
      foldStatus: false,
      overviewTimeData: { timetype: 5 },
      detailTimeData: { timetype: 5 },
      tendencyTimeData: { timetype: 5 },
      rowDirection: 'iconicon-test17',
      listDatas: [],
      dataType: null,
      checkIndexs: null,
      levelText: this.$t('message["905"]'),
      teamLists: [],
      defaultTeamName: '',
      // 词云图
      wordcloudOption: highChartWordCloudOption(),
      isWordCloud: false,
      wordLegendPage: 1,
      devDistributelist: {}
    }
  },
  computed: {
    ...mapState('statistic', ['devRecOverViewDatas', 'formateRangeDatasStatus', 'levelList', 'devDistributeDatas', 'detailTableDatas']),
    rangeTitTxt () {
      return this.$t('message["288"]')
    },
    overviewTxt () {
      return this.$t('message["293"]')
    },
    overviewTitTxt () {
      return this.$t('message["346"]')
    },
    dataTitTxt () {
      return this.$t('message["1130"]')
    }

  },
  watch: {
    devDistributeDatas (val) {
      if (!val) return
      this.isWordCloud = 'hotKeywords' in val
      if (this.isWordCloud) {
        this.devDistributelist = val
        this.drawWordCloud(val)
      } else {
        this.drawPie(this.formateDistributeData(val))
      }
      document.title = `${this.$t('message["1369"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    },
    detailTableDatas: {
      handler (val) {
        if (!val) return
        if (val.length <= 0) return
        if (val.config[1]) {
          if (val.config[1].options) {
            this.defaultTeamName = val.config[1].name
            const options = val.config[1].options
            const tempv = []
            for (const key in options) {
              tempv.push({ value: key, name: options[key][0] })
            }
            this.teamLists = tempv
          } else {
            this.teamLists = []
            this.defaultTeamName = ''
            if (!this.checkIndexs) {
              this.checkIndexs = 1
            }
          }
        }
        this.listDatas = val.data
        this.dataType = val.type
      },
      immediate: true
    }
  },
  mounted () {
    this.fetchGetMemberRangeDatas()
    this.fetchGetDevRecOverView(this.overviewTimeData)
    this.fetchDevDistributeDatas(this.tendencyTimeData)
    this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
  },
  methods: {
    ...mapActions('statistic', ['fetchGetMemberRangeDatas', 'fetchGetDevRecOverView', 'fetchDevDistributeDatas', 'fetchGetDetailTableDatas']),
    drawPie (json) {
      this.$nextTick(() => {
        if (this.$refs.distributeRef) {
          this.$refs.distributeRef.chartObj.title.update({ text: `<p style="font-size: 16px;color:#666666;text-align:center">${this.$t('message["1374"]')}</p><p style=" font-family: Roboto;font-size: 32px;text-align:center;color: #333333;">${json.total}</p>` })
          this.$refs.distributeRef.chartObj.series[0].update({
            type: 'pie',
            innerSize: '80%',
            name: this.$t('message["1374"]'),
            data: json.data
          })
        }
      })
    },
    drawWordCloud (value) {
      this.$nextTick(() => {
        if (this.$refs.wordRef) {
          this.prepareWordCloud(value.hotKeywords)
          this.$refs.wordRef.chartObj.series[0].update({
            type: 'wordcloud',
            innerSize: '90%',
            data: this.prepareWordCloud(value.hotKeywords),
            arr: value.data
          })
        }
      })
    },
    // 减少词云元数据之间的倍数
    prepareWordCloud (value) {
      let aWeight = value.map(item => item.weight)
      let max = Math.max.apply(null, aWeight) // 最大值
      let middle = Math.floor(max / 2) // 基数
      let wordKeys = value.map(item => {
        item.name = item.name.length > 10 ? item.name.slice(0, 10) : item.name
        item.weight = (max / item.weight) > middle ? item.weight + middle : item.weight
        return item
      })
      return wordKeys
    },
    handleTeamSelectFollow (value) {
      if (!value) return
      this.detailTimeData.groupType = value
      this.fetchGetDetailTableDatas({ ...this.detailTimeData, page: 1 })
    },
    handleCascaderSubmit (value) {
      const tempValue = value.value
      let json = {}
      if (Array.isArray(tempValue)) {
        tempValue.map(item => {
          json[item.keyname] = item.id
        })
      }
      delete this.detailTimeData.userid
      delete this.detailTimeData.groupid
      delete this.detailTimeData.roleid
      delete this.overviewTimeData.userid
      delete this.overviewTimeData.groupid
      delete this.overviewTimeData.roleid
      delete this.tendencyTimeData.userid
      delete this.tendencyTimeData.groupid
      delete this.tendencyTimeData.roleid
      if (tempValue.length === 0) {
        this.fetchGetDevRecOverView({ ...this.overviewTimeData })
        this.fetchDevDistributeDatas({ ...this.tendencyTimeData })
        this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
      } else {
        this.overviewTimeData = Object.assign(this.overviewTimeData, json)
        this.detailTimeData = Object.assign(this.detailTimeData, json)
        this.tendencyTimeData = Object.assign(this.tendencyTimeData, json)
        this.fetchGetDevRecOverView({ ...this.overviewTimeData })
        this.fetchDevDistributeDatas({ ...this.tendencyTimeData })
        this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
      }
    },
    handleMessageChange (value) {
      const tempValue = value.value
      if (Array.isArray(tempValue)) {
        // const params = {
        //   from: ''
        // }
        if (tempValue.length === 1) {
          this.tendencyTimeData.from = tempValue[0].id
        } else if (tempValue.length === 2) {
          this.tendencyTimeData.from = tempValue[1].id
        } else if (tempValue.length === 3) {
          this.tendencyTimeData.from = tempValue[1].id
        }
        if (this.tendencyTimeData.from === '-1') {
          delete this.tendencyTimeData.from
        }
        this.fetchDevDistributeDatas({ ...this.tendencyTimeData })
      }
    },
    handleLevelSelect () {
      this.visible = true
    },
    handleLevelSelectChange (value) {
      this.levelText = value.name
      if (value.id === -1) {
        this.checkIndexs = 1
        delete this.detailTimeData.level
      } else {
        this.checkIndexs = value.id + 1
        this.detailTimeData.level = value.id
      }
      if (this.dataType === 1) {
        this.fetchGetDetailTableDatas({ ...this.detailTimeData, page: 1 })
      }
    },
    handleDateChange (value, flag) {
      if (flag === 0) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.overviewTimeData.timetype
          this.overviewTimeData.starttime = starttime
          this.overviewTimeData.endtime = endtime
        } else {
          delete this.overviewTimeData.starttime
          delete this.overviewTimeData.endtime
          this.overviewTimeData.timetype = value.value
        }
        this.fetchGetDevRecOverView(this.overviewTimeData)
      } else if (flag === 1) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.tendencyTimeData.timetype
          this.tendencyTimeData.starttime = starttime
          this.tendencyTimeData.endtime = endtime
        } else {
          delete this.tendencyTimeData.starttime
          delete this.tendencyTimeData.endtime
          this.tendencyTimeData.timetype = value.value
        }
        this.fetchDevDistributeDatas(this.tendencyTimeData)
      } else if (flag === 2) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.detailTimeData.timetype
          this.detailTimeData.starttime = starttime
          this.detailTimeData.endtime = endtime
        } else {
          delete this.detailTimeData.starttime
          delete this.detailTimeData.endtime
          this.detailTimeData.timetype = value.value
        }
        this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
      }
    },
    formateDistributeData (obj) {
      const json = {
        total: obj.total,
        data: []
      }
      if (Array.isArray(obj.data)) {
        obj.data.map(value => {
          const pers = value.per.substring(0, value.per.length - 1).substring(0, 4) * 1
          json.data.push({ name: value.name, y: pers, num: value.num })
        })
      }
      return json
    },
    handleTypeChange (result) {
      const { value } = result
      if (value === 0) {
        delete this.detailTimeData.info_type
      } else {
        this.detailTimeData.info_type = value
      }
      console.log(this.detailTimeData)
      this.fetchGetDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    toSelectPage () {
      if (!this.picker) {
        let pages = Array.from(Array(this.devDistributelist.maxPage), (v, k) => {
          return { text: `${(k + 1)}/${this.devDistributelist.maxPage}`, value: k + 1 }
        })
        this.picker = this.$createPicker({
          title: '',
          data: [pages],
          onSelect: this.selectPageHandle
        })
      }
      this.picker.show()
    },
    selectPageHandle (val) {
      const [page] = val
      this.wordLegendPage = page
      this.fetchDevDistributeDatas({ ...this.tendencyTimeData, page })
    },
    toPrev () {
      const page = this.wordLegendPage - 1
      if (page >= 1) {
        this.wordLegendPage = page
        this.fetchDevDistributeDatas({ ...this.tendencyTimeData, page })
      }
    },
    toNext () {
      const page = this.wordLegendPage + 1
      if (page <= this.devDistributelist.maxPage) {
        this.wordLegendPage = page
        this.fetchDevDistributeDatas({ ...this.tendencyTimeData, page })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.word_main {
  position: relative;
}
.wordcloud {
  .wordcloud_operate {
    width: 100%;
    position: absolute;
    bottom: 20px;
    text-align: center;
    animation: show_page .3s;
    @keyframes show_page {
      from {
        opacity: 0;
      }
      to{
        opacity: 1;
      }
    }
    .pagin {
      display: inline-flex;
      flex-direction: row;
      justify-content: center;
      margin: 0 auto;
      .page_select {
        width: 76px;
        height: 28px;
        background: #fff;
        border-radius: 2px;
        border: 1px solid #d6d6d6;
        margin: 0 7px;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        vertical-align: middle;
        .iconfont {
          font-size: 8px;
          color: #ccc;
          margin: 0 0 0 10px;
          vertical-align: middle
        }
      }
      span {
        display: inline-block;
        width: 28px;
        height: 28px;
        border-radius: 2px;
        border: 1px solid #d6d6d6;
        text-align: center;
        line-height: 28px;
        vertical-align: middle;
        i {
          color: #333;
        }
        .pagin_null {
          color: #d6d6d6;
        }
      }
      span:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
